import { render, staticRenderFns } from "./HabeasDataManagement.vue?vue&type=template&id=0f1b3390&scoped=true"
import script from "./HabeasDataManagement.vue?vue&type=script&lang=js"
export * from "./HabeasDataManagement.vue?vue&type=script&lang=js"
import style0 from "./HabeasDataManagement.vue?vue&type=style&index=0&id=0f1b3390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b3390",
  null
  
)

export default component.exports